import service from '@/store/services/permissions-service';

const state = {
    list: {},
    role: {},
    permission: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, permission) => {
        state.permission = permission;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then((permission) => {
                commit('SET_RESOURCE', permission);
            });
    },

    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((permission) => {
                commit('SET_RESOURCE', permission);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((permission) => {
                commit('SET_RESOURCE', permission);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    roles ({ commit, dispatch }, params) {
        return service.roles(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    permission: state => state.permission,
    role: state => state.role,
    dropdown: (state) => {
        return state.list.map(permission => ({
            id: permission.id,
            name: permission.name,
            guard_name: permission.guard_name
        }));
    }
};

const permissions = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default permissions;
